import { CareType } from '@pflegia/types/api/employer/care-type';
import { EMPLOYER_SCORES } from '@pflegia/types/api/kam-list/scores';

export const canHaveGeoArea = (careType: CareType) => [CareType.Ambulant, CareType.IntensiveAmbulant, CareType.Leasing].includes(careType);

export const calculateEmployerScore = (matches: number, invitations: number) => {
  if (invitations === 0) return 'T4';

  const rate = matches / invitations;
  switch (true) {
    case rate >= EMPLOYER_SCORES['T1'].limit:
      return 'T1';
    case rate > EMPLOYER_SCORES['T2'].limit:
      return 'T2';
    case rate > EMPLOYER_SCORES['T3'].limit:
      return 'T3';
    default:
      return 'T4';
  }
};
